import React from 'react';
import { ToastType, TOAST_DEFAULT_DURATIONS, pushToast } from './toastStore';

// Matches antd's own `message.success/error/warning/info` call shapes --
// either the content directly, or an options object with an optional
// `duration` override in seconds (same unit antd used) -- so every one of
// this app's existing call sites keeps working unchanged; only each
// file's import of `message` needs to point here instead of 'antd'.
type MessageArg = React.ReactNode | { content: React.ReactNode; duration?: number };

const resolveArg = (arg: MessageArg): { content: React.ReactNode; durationSeconds?: number } => {
  if (arg != null && typeof arg === 'object' && !React.isValidElement(arg) && 'content' in (arg as object)) {
    const options = arg as { content: React.ReactNode; duration?: number };
    return { content: options.content, durationSeconds: options.duration };
  }
  return { content: arg as React.ReactNode, durationSeconds: undefined };
};

const show = (type: ToastType, arg: MessageArg) => {
  const { content, durationSeconds } = resolveArg(arg);
  const duration = durationSeconds != null ? durationSeconds * 1000 : TOAST_DEFAULT_DURATIONS[type];
  pushToast(type, content, duration);
};

export const message = {
  success: (arg: MessageArg) => show('success', arg),
  error: (arg: MessageArg) => show('error', arg),
  warning: (arg: MessageArg) => show('warning', arg),
  info: (arg: MessageArg) => show('info', arg),
};
